import { render, staticRenderFns } from "./bodyFunctionAdd.vue?vue&type=template&id=3396c55d&scoped=true&"
import script from "./bodyFunctionAdd.vue?vue&type=script&lang=js&"
export * from "./bodyFunctionAdd.vue?vue&type=script&lang=js&"
import style0 from "./bodyFunctionAdd.vue?vue&type=style&index=0&id=3396c55d&prod&lang=scss&scoped=true&"
import style1 from "./bodyFunctionAdd.vue?vue&type=style&index=1&id=3396c55d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3396c55d",
  null
  
)

export default component.exports